import React, { useState, useEffect } from 'react'
import { blindShuffle } from '../utils/SmartLabelUtils'
import 'katex/dist/katex.min.css'
import { KnovaText } from '../BasicUIComponents/KnovaText'
import { Grid, Column } from 'carbon-components-react'

function SCMultipleAnswer(props) {
  const {
    isPractice,
    Completed,
    isActive,
    componentData,
    themeColors,
    themeFont,
    themeStyles,
    isSideMenu,
    isFollowTheFlow,
    priorityActive,
    isAudioPlaying,
    isReplaying
  } = props
  const {
    onValueChange,
    defaultValue,
    onPriorityChange,
    handleSucAndFailFeedback
  } = props

  const {
    ControlID,
    Options,
    Answers,
    Score,
    QuestionText,
    LayoutType,
    Priority,
    FeedbackAudioData
  } = componentData

  const [selectedAnswer, setSelectedAnswer] = useState([])
  const [sortedChoiceValueArray, setSortedChoiceValueArray] = useState([])
  const [correctAnswer, setCorrectAnswer] = useState([])
  const [onBlurCall, setOnBlurCall] = useState(true)
  const [failureCount, setFailureCount] = useState(0)

  useEffect(() => {
    let correctAnswerCopy = []
    for (let index = 0; index < Answers.length; index++) {
      let answerIndex = Answers[index]
      correctAnswerCopy.push(Options[answerIndex].Option)
    }
    setCorrectAnswer(correctAnswerCopy)
  }, [])

  // useEffect(() => {
  //   if (Object.keys(componentData).length > 0) {
  //     setSortedChoiceValueArray(blindShuffle(Options))
  //   }
  // }, [componentData])

  useEffect(() => {
    if (onBlurCall) {
      if (defaultValue) {
        if (defaultValue.CtlSortedArray) {
          setSortedChoiceValueArray(defaultValue.CtlSortedArray)
        } else {
          setSortedChoiceValueArray(blindShuffle(Options))
        }
        if (defaultValue.CtlValue) {
          let defaultValueSelected = defaultValue.CtlValue
          setSelectedAnswer(defaultValueSelected)
        }
        setOnBlurCall(false)
      } else {
        setSortedChoiceValueArray(blindShuffle(Options))
        let selectedAnswerCopy = []
        for (let index = 0; index < Options.length; index++) {
          selectedAnswerCopy.push(undefined)
        }
        setSelectedAnswer(selectedAnswerCopy)
      }
    }
  }, [defaultValue, onBlurCall])

  //Failure message Sequence
  function handleFailureFeedback(selectedIndex) {
    let selectedOption = Options[selectedIndex]
    let feedbackAudioData = selectedOption.FeedbackAudioData.failureData
    let failureFeedback = {}
    if (feedbackAudioData.length > 0) {
      if (failureCount === 0) {
        if (feedbackAudioData[1]) {
          setFailureCount(1)
        } else {
          setFailureCount(0)
        }
        failureFeedback = feedbackAudioData[0]
      } else if (failureCount === 1) {
        if (feedbackAudioData[2]) {
          setFailureCount(2)
        } else {
          setFailureCount(0)
        }
        failureFeedback = feedbackAudioData[1]
      } else if (failureCount === 2) {
        setFailureCount(0)
        failureFeedback = feedbackAudioData[2]
      }
    } else {
      failureFeedback = {
        failureAudioLink: '',
        failureFeedback: []
      }
    }
    handleSucAndFailFeedback(false, failureFeedback)
  }

  function handleOptionChange(indexValue, optionValue) {
    // onAttemptChange(1)
    let selectedAnswerCopy = [...selectedAnswer]
    if (selectedAnswer.includes(optionValue)) {
      selectedAnswerCopy[indexValue] = undefined
    } else {
      selectedAnswerCopy[indexValue] = optionValue
    }
    setSelectedAnswer(selectedAnswerCopy)
    validateCorrectAnswer(false, selectedAnswerCopy)
  }

  function validateCorrectAnswer(timerValue, selectedAnswerCopy) {
    let correctAnswerCopy = []
    let newArray = []
    for (let i = 0; i < selectedAnswerCopy.length; i++) {
      let match = false
      for (let j = 0; j < correctAnswer.length; j++) {
        if (selectedAnswerCopy[i] === correctAnswer[j]) {
          match = true
          correctAnswerCopy.push(selectedAnswerCopy[i])
        }
      }
      if (!match) {
        newArray.push(selectedAnswerCopy[i])
      }
    }
    let newArrayCopy = []
    for (let index = 0; index < newArray.length; index++) {
      newArrayCopy.push(undefined)
    }

    //Change priority value
    if (onPriorityChange && isFollowTheFlow) {
      if (isPractice) {
        if (JSON.stringify(newArray) === JSON.stringify(newArrayCopy)) {
          if (correctAnswerCopy.length === correctAnswer.length) {
            onPriorityChange(Priority)
          }
        }
      } else {
        onPriorityChange(Priority)
      }
    }

    if (JSON.stringify(newArray) === JSON.stringify(newArrayCopy)) {
      if (correctAnswerCopy.length === correctAnswer.length) {
        onValueChange(
          ControlID,
          selectedAnswerCopy,
          Score,
          Score,
          sortedChoiceValueArray,
          false
        )
        if (isPractice && isFollowTheFlow) {
          handleSucAndFailFeedback(true, FeedbackAudioData.successData)
        }
      } else {
        onValueChange(
          ControlID,
          selectedAnswerCopy,
          0,
          Score,
          sortedChoiceValueArray,
          false
        )
        if (isPractice && isFollowTheFlow) {
          let selectedCopy = []
          for (let index = 0; index < selectedAnswerCopy.length; index++) {
            if (selectedAnswerCopy[index]) {
              selectedCopy.push(selectedAnswerCopy[index])
            }
          }
          if (selectedCopy.length === correctAnswer.length) {
            handleFailureFeedback()
          }
        }
      }
    } else {
      onValueChange(
        ControlID,
        selectedAnswerCopy,
        0,
        Score,
        sortedChoiceValueArray,
        false
      )
      if (isPractice && isFollowTheFlow) {
        let selectedCopy = []
        for (let index = 0; index < selectedAnswerCopy.length; index++) {
          if (selectedAnswerCopy[index]) {
            selectedCopy.push(selectedAnswerCopy[index])
          }
        }
        if (selectedCopy.length === correctAnswer.length) {
          handleFailureFeedback()
        }
      }
    }
  }

  function validateAnswer() {
    let correctAnswerCopy = []
    let newArray = []
    let isCorrect = false
    for (let i = 0; i < selectedAnswer.length; i++) {
      let match = false
      for (let j = 0; j < correctAnswer.length; j++) {
        if (selectedAnswer[i] === correctAnswer[j]) {
          match = true
          correctAnswerCopy.push(selectedAnswer[i])
        }
      }
      if (!match) {
        newArray.push(selectedAnswer[i])
      }
    }
    let newArrayCopy = []
    for (let index = 0; index < newArray.length; index++) {
      newArrayCopy.push(undefined)
    }

    if (JSON.stringify(newArray) === JSON.stringify(newArrayCopy)) {
      if (correctAnswerCopy.length === correctAnswer.length) {
        isCorrect = true
      } else {
        isCorrect = false
      }
    }
    return isCorrect
  }

  return (
    <div
      className='sc-mcq-contn'
      style={{
        filter: isFollowTheFlow
          ? Priority <= priorityActive
            ? 'unset'
            : 'blur(3px)'
          : 'unset',
        pointerEvents:
          Completed === 1 || !isActive || isAudioPlaying || isReplaying
            ? 'none'
            : isFollowTheFlow
            ? isPractice
              ? Priority === priorityActive
                ? 'auto'
                : 'none'
              : Priority > priorityActive
              ? 'none'
              : 'auto'
            : 'auto'
      }}
    >
      {QuestionText && (
        <KnovaText
          contPadding={isSideMenu ? '0px' : '12px'}
          text={QuestionText}
          textColor={themeColors.onBackground}
          textFontSize={isSideMenu ? '5px' : '18px'}
          textFontFamily={themeFont.bodyFont}
          textFontWeight='400'
        />
      )}
      <div className='mcq-style'>
        <Grid
          className='mcq-grid-style'
          style={{
            gap: isSideMenu ? '5px' : '19px'
          }}
        >
          {sortedChoiceValueArray.map((optionData, index) => {
            const isCorrectAnswer = correctAnswer.includes(optionData.Option)
            const isSelected =
              selectedAnswer.length > 0 &&
              selectedAnswer.includes(optionData.Option)
            return (
              <Column
                key={'mcaOptions' + index}
                className='mcq-option-style'
                lg={LayoutType === 'small' ? 8 : 16}
                md={LayoutType === 'small' ? 4 : 8}
                sm={LayoutType === 'small' ? 2 : 4}
                onClick={() => {
                  if (isPractice && isFollowTheFlow) {
                    let isCorrect = validateAnswer()
                    if (isCorrect && priorityActive > Priority) {
                    } else {
                      if (Completed === 0 && isActive) {
                        handleOptionChange(index, optionData.Option)
                      }
                    }
                  } else {
                    if (Completed === 0 && isActive) {
                      handleOptionChange(index, optionData.Option)
                    }
                  }
                }}
              >
                <KnovaText
                  contBgColor={
                    isPractice || Completed === 1 || !isActive
                      ? isSelected
                        ? isCorrectAnswer
                          ? themeColors.successContainer
                          : themeColors.errorContainer
                        : themeColors.surfaceVarient
                      : isSelected
                      ? themeStyles.selectionColor
                      : themeColors.surfaceVarient
                  }
                  contPadding={isSideMenu ? '2px' : '24px'}
                  contBorderColor={
                    isPractice || Completed === 1 || !isActive
                      ? isSelected
                        ? isCorrectAnswer
                          ? themeColors.success
                          : themeColors.error
                        : themeColors.outline
                      : isSelected
                      ? themeColors.outlineVarient
                      : themeColors.outline
                  }
                  contBorderWidth={isSideMenu ? '1px' : '2px'}
                  contBorderRadius={isSideMenu ? '4px' : '12px'}
                  text={
                    isSideMenu ? 'Question ' + (index + 1) : optionData.Option
                  }
                  textColor={
                    isPractice || Completed === 1 || !isActive
                      ? isSelected
                        ? isCorrectAnswer
                          ? themeColors.onSuccess
                          : themeColors.onError
                        : themeColors.onSurfaceVarient
                      : isSelected
                      ? themeStyles.selectionTextColor
                      : themeColors.onSurfaceVarient
                  }
                  textFontSize={isSideMenu ? '5px' : '16px'}
                  textFontFamily={themeFont.bodyFont}
                  textFontWeight={isSelected ? '700' : '400'}
                  cursor='pointer'
                  textAlign={LayoutType === 'centered' ? 'center' : 'left'}
                />
              </Column>
            )
          })}
        </Grid>
      </div>
    </div>
  )
}

export default SCMultipleAnswer
